import CampoEnum from "../../domain/protocolo/CampoEnum";
import ProtocoloEnum from "../../domain/protocolo/ProtocoloEnum";
import ConvenioService from "../../domain/secretaria/ConvenioService";

export default {
  computed: {
    ambienteAtual() {
      return this.$store.state.ambientes.atual;
    }
  },
  methods: {
    $isLocalOutros(protocolo) {
      return ["Outro", ""].includes(protocolo.campos[CampoEnum.LOCAL_ESTAGIO]);
    },
    setResponsavel(protocolo) {
      protocolo.campos[CampoEnum.NOME_EMPRESA] =
        "CEI - Centro Educacional Integrado LTDA";
      protocolo.campos[CampoEnum.NOME_RESPONSAVEL_EMPRESA] =
        "Alan Sales da Fonseca";
      protocolo.campos[CampoEnum.TELEFONE_RESPONSAVEL_EMPRESA] =
        "(44) 3518-2500";
      protocolo.campos[CampoEnum.CELULAR_RESPONSAVEL_EMPRESA] =
        "(44) 3518-2500";
      protocolo.campos[CampoEnum.EMAIL_RESPONSAVEL_EMPRESA] =
        "saa@grupointegrado.br";
      protocolo.campos[CampoEnum.TIPO_PESSOA] = "juridica";
    },
    setValuesIntegrado(protocolo) {      
      let campo = protocolo.campos[CampoEnum.LOCAL_ESTAGIO];
     
      if (campo == "Centro Universitário Integrado - Centro") {
        this.setResponsavel(protocolo);
        protocolo.campos[CampoEnum.CNPJ] = "79.264.628/0001-54";
        protocolo.campos[CampoEnum.CEP_EMPRESA] = "87301-010";
        protocolo.campos[CampoEnum.ENDERECO_EMPRESA] = "Avenida Irmãos Pereira";
        protocolo.campos[CampoEnum.NUMERO_EMPRESA] = "670";
        protocolo.campos[CampoEnum.BAIRRO_EMPRESA] = "Centro";
        protocolo.campos[CampoEnum.CIDADE_EMPRESA] = "Campo Mourão";
        protocolo.campos[CampoEnum.ESTADO_EMPRESA] = "PR";
      }
      if (campo == "Centro Universitário Integrado - Campus") {
        this.setResponsavel(protocolo);
        protocolo.campos[CampoEnum.CNPJ] = "79.264.628/0003-16";
        protocolo.campos[CampoEnum.CEP_EMPRESA] = "87309-701";
        protocolo.campos[CampoEnum.ENDERECO_EMPRESA] = "Rua Lauro de Oliveira Souza";
        protocolo.campos[CampoEnum.NUMERO_EMPRESA] = "440";
        protocolo.campos[CampoEnum.BAIRRO_EMPRESA] = "Área Urbanizada II";
        protocolo.campos[CampoEnum.CIDADE_EMPRESA] = "Campo Mourão";
        protocolo.campos[CampoEnum.ESTADO_EMPRESA] = "PR";
      }
      if (campo == "Centro Universitário Integrado - Serviços") {
        this.setResponsavel(protocolo);
        protocolo.campos[CampoEnum.CNPJ] = "79.264.628/0002-35";
        protocolo.campos[CampoEnum.CEP_EMPRESA] = "87301-010";
        protocolo.campos[CampoEnum.ENDERECO_EMPRESA] = "Avenida Irmãos Pereira";
        protocolo.campos[CampoEnum.NUMERO_EMPRESA] = "870";
        protocolo.campos[CampoEnum.BAIRRO_EMPRESA] = "Centro";
        protocolo.campos[CampoEnum.CIDADE_EMPRESA] = "Campo Mourão";
      }

      if (campo == "" || campo == "Outro") {
        protocolo.campos[CampoEnum.NOME_EMPRESA] = null;
        protocolo.campos[CampoEnum.NOME_RESPONSAVEL_EMPRESA] = null;
        protocolo.campos[CampoEnum.TELEFONE_RESPONSAVEL_EMPRESA] = null;
        protocolo.campos[CampoEnum.CELULAR_RESPONSAVEL_EMPRESA] = null;
        protocolo.campos[CampoEnum.EMAIL_RESPONSAVEL_EMPRESA] = null;
        protocolo.campos[CampoEnum.CEP_EMPRESA] = null;
        protocolo.campos[CampoEnum.ENDERECO_EMPRESA] = null;
        protocolo.campos[CampoEnum.NUMERO_EMPRESA] = null;
        protocolo.campos[CampoEnum.BAIRRO_EMPRESA] = null;
        protocolo.campos[CampoEnum.CIDADE_EMPRESA] = null;
        protocolo.campos[CampoEnum.ESTADO_EMPRESA] = null;
        // protocolo.campos[CampoEnum.TIPO_PESSOA] = null;
        protocolo.campos[CampoEnum.CPF] = null;
        protocolo.campos[CampoEnum.CNPJ] = null;
      }
    },
    setValuesConvenio(protocolo, convenio) {
      protocolo.campos[CampoEnum.NOME_EMPRESA] = convenio.empresa;
      protocolo.campos[CampoEnum.CEP_EMPRESA] = convenio.cep;
      protocolo.campos[CampoEnum.ENDERECO_EMPRESA] = convenio.rua;
      protocolo.campos[CampoEnum.NUMERO_EMPRESA] = convenio.numero;
      protocolo.campos[CampoEnum.BAIRRO_EMPRESA] = convenio.bairro;
      protocolo.campos[CampoEnum.CIDADE_EMPRESA] = convenio.cidade;
      protocolo.campos[CampoEnum.ESTADO_EMPRESA] = convenio.estado;
    },
    $getConvenioValidoByInscricao(protocolo, value) {
      if (!value) {
        return;
      }
      this.$emit("update:loading", true);

      const convenioService = new ConvenioService(this.$http);
      return convenioService
        .getConvenioValidoByInscricao(value)
        .then(convenio => {
          const isConvenio = convenio.length > 0;
          let isAlterarCampos = !isConvenio;

          convenio = convenio[0] || {};

          let values = Object.assign(
            {
              empresa: null,
              cep: null,
              rua: null,
              numero: null,
              bairro: null,
              cidade: null,
              estado: null
            },
            convenio
          );

          this.setValuesConvenio(protocolo, values);

          this.$emit("update:loading", false);
        });
    },
    $updateValuesConvenio(value = null) {
      let protocolo = this.formValues.protocolo[
        ProtocoloEnum.TERMO_COMPROMISSO_ESTAGIO
      ];
      if (!protocolo) {
        protocolo = this.formValues.protocolo[
          ProtocoloEnum.TERMO_COMPROMISSO_ESTAGIO_EAD
        ];
      }
      if (!protocolo && this.ambienteAtual.idAmbiente == 8) {
        protocolo = this.formValues.protocolo[
          ProtocoloEnum.TERMO_COMPROMISSO_ESTAGIO_MEDICINA
        ];
      }
      if (this.$isLocalOutros(protocolo) && value) {
        return this.$getConvenioValidoByInscricao(protocolo, value);
      }
      this.setValuesIntegrado(protocolo);
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixins/protocolo/convenio.js